import React from "react";
import Exercise from "./Workout";
import { Link, useParams } from "react-router-dom";

function ShowExercise() {
  // we need the id for the exercise to reach it
  const { exerciseId } = useParams();
  const [exercise, setExercise] = React.useState(undefined);

  React.useEffect(() => {
    async function fetchWorkOut() {
      const resp = await fetch(
        `https://exercisedb.p.rapidapi.com/exercises/exercise/${exerciseId}`,
        {
          method: "GET",
          headers: {
            "x-rapidapi-host": process.env.REACT_APP_APIHOST,
            "x-rapidapi-key": process.env.REACT_APP_APIKEY,
          },
        }
      );
      const data = await resp.json();
      setExercise(data);
    }
    fetchWorkOut();
    //eslint-disable-next-line
  }, []);

  if (!exercise) {
    return <p>Loading</p>;
  }
  return (
    <div>
      <div>
        <Link to="/exercises" className="font-bold">
          ←{"Back to Exercises"}
        </Link>
      </div>
      <div className="flex flex-col justify-center items-center h-screen">
        <Exercise exercise={exercise} />
      </div>
    </div>
  );
}

export default ShowExercise;
